import React from 'react'
import styled from 'styled-components'
import { Box, TextBody } from '@ally/metronome-ui'
import { STALE_DATA_COPY } from '../../../constants'
import { getDashDash } from '../../../utils'
import { TextBodyOverride } from '../../Shared'

const StyledWrapper = styled.div`
  background-color: transparent;
  padding: 0;
  border: none;
  display: flex;
  cursor: pointer;
  margin: 0;
  width: 100%;
  white-space: normal;
`

const FormattedCurrency: React.FC<{ value: number }> = ({ value }) => (
  <TextBodyOverride tag="p" size="md" color={value < 0 ? 'error' : 'slate-5'}>
    {Intl.NumberFormat('en-us', {
      style: 'currency',
      currency: 'USD',
    }).format(value)}
  </TextBodyOverride>
)

const MobileWealthCardDetail: React.FC<{
  hasOnlyClosedAccounts?: boolean
  totalValue: number
  hasStaleData?: boolean
}> = ({ hasOnlyClosedAccounts = false, totalValue, hasStaleData = false }) => {
  const showBalance = Number.isFinite(totalValue)

  return (
    <StyledWrapper>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        borderLeftStyle="solid"
        borderLeftWidth="7px"
        p="xs"
        borderTop="1px solid"
        borderTopColor="slate-2"
        borderRadius="4px 4px 0 0"
        width="100%"
      >
        <Box
          display="flex"
          flex={1}
          flexDirection="column"
          alignItems="flex-start"
          textAlign="left"
        >
          <Box display="flex" flexDirection="column">
            <TextBodyOverride
              tag="span"
              color="bluesuedeshoes"
              size="lg"
              weight="bold"
            >
              Wealth Overview
            </TextBodyOverride>
          </Box>
        </Box>
        <Box
          display="flex"
          flex={1}
          flexDirection="column"
          alignItems="flex-end"
        >
          {hasOnlyClosedAccounts ? (
            <TextBody tag="p" size="md" type="error">
              CLOSED
            </TextBody>
          ) : (
            <>
              <Box>
                <TextBody tag="p" size="md" weight="bold">
                  Account Value
                </TextBody>
              </Box>
              {hasStaleData
                ? getDashDash(STALE_DATA_COPY)
                : showBalance && (
                    <Box>
                      <FormattedCurrency value={totalValue} />
                    </Box>
                  )}
            </>
          )}
        </Box>
      </Box>
    </StyledWrapper>
  )
}

export default MobileWealthCardDetail
